
  <template>
<v-layout justify-center align-center>
  <div class="login">
    <v-card width="400px"  class="slightlypadded stickytopconscious">
      <v-img src='@/assets/logo.png' max-height="200px" contain>
      </v-img>
    <h3 class="signinpad">Sign In</h3>
    <input class="signinpad" type="text" v-model="email" placeholder="Email" size="12"><br>
    <input class="signinpad" type="password" v-model="password" placeholder="Password" @keydown.enter="loginWithFirebase"><br>
    <v-layout justify-end>
    <v-btn @click="loginWithFirebase" class="mx-3 my-3 primary">Sign In</v-btn>
     </v-layout>
  </v-card>
</div>
</v-layout>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'


  export default {
    name: 'login',
    data() {
      return {
        email: '',
        password: '',
        usertest: ''
      }
    },
     computed: {
      userLoggedIn () {
      return this.$store.getters.user
    }
    },

    watch: {
      userLoggedIn (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/Welcome')
        }
      }
    },
    methods: {

      loginWithFirebase () {
      const user = {
        email: this.email,
        password: this.password
      }
      this.$store.dispatch('signInAction', user)

    }

  }
    }



</script>

<style scoped>
.signinpad {
  padding: 5%
}
  .login {
    margin-top: 40px;
    color: black
  }
  .logincard {
    padding: 10%
  }
  input {
    margin: 10px 0;
    width: 100%;
    padding: 15px;
  }
  button {
    margin-top: 20px;
    width: 10%;
    cursor: pointer;
  }
  p {
    margin-top: 40px;
    font-size: 13px;
  }
  p a {
    text-decoration: underline;
    cursor: pointer;
  }
  .social-button {
    width: 75px;
    background: white;
    padding: 10px;
    border-radius: 100%;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.2);
    outline: 0;
    border: 0;
  }
  .social-button:active {
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1);
  }
  .social-button img {
    width: 100%;
  }
.stickytopconscious{
  top: 100px
}
</style>


  